/* eslint-disable */
export default {
  allCalls: '모든 통화',
  Unknown: '알 수 없음',
  Multiple: '다중',
} as const;

// @key: @#@"allCalls"@#@ @source: @#@"All calls"@#@
// @key: @#@"Unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"Multiple"@#@ @source: @#@"Multiple"@#@
